import { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { Card } from 'antd'
import CardMsgItem from './CardMsgItem'
import * as api from '@/api/workbench'
import icon1 from '@/assets/images/workbench/xzcwdb.png'
import icon2 from '@/assets/images/workbench/xmdb.png'
import icon3 from '@/assets/images/workbench/yfdcd.png'
import icon4 from '@/assets/images/workbench/tbbzj.png'
import icon5 from '@/assets/images/workbench/drgzqk.png'

type SpItemProp = FC<PropsWithChildren<{
  items: {label: string, value: string}[]
  
}>>
const SpItem: SpItemProp = ({items}) => {
  return (
    <div className='text-999 grow-1'>
      <div>{items[0].label}：<span className='text-333 font-700 font-16'>{items[0].value}</span></div>
      <div className='mt-16'>{items[1].label}：<span className='text-333 font-700 font-16'>{items[1].value}</span></div>
    </div>
  )
}

type PropType = FC<PropsWithChildren<{
  count: any
}>>

const TopRight: PropType = ({count}) => {

  return (
    <Card size="small">
      <div className='flex ptb-6'>
        <CardMsgItem icon={icon1} className='grow-1' unit='条' label='行政财务待办' value='12' />
        <CardMsgItem icon={icon2} className='grow-1' unit='条' label='项目待办' value='12' />
        <CardMsgItem icon={icon3} className='grow-1' unit='条' label='预付待冲抵' value='12' />
        <CardMsgItem icon={icon4} className='grow-1' unit='元' label='投标保证金' value='3291' />
        {/* <div className='border-left pl-10 mr-10 ml-10'>
          <img src={icon5} alt=''/>
        </div>
        <SpItem items={[{label: '审批单据', value: count.CNT_DRZGQK_SPDJ || 0}, {label: '提交单据', value: count.CNT_DRZGQK_TJDJ || 0}]} />
        <SpItem items={[{label: '审批通过', value: count.CNT_DRZGQK_SPTG || 0}, {label: '完成单据', value: count.CNT_DRZGQK_WCDJ || 0}]} />
        <SpItem items={[{label: '审批驳回', value: count.CNT_DRZGQK_SPBH || 0}, {label: '平均处理时长', value: count.CNT_DRZGQK_PJCLSC || 0}]} /> */}
      </div>
    </Card>
  )
}

export default TopRight
